import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { formatDateTime } from '@euler/utils/formatters/datetime';
import { memo } from 'react';
import { View } from 'react-native';
import { designRoles } from '../common/designRoles';

/** One message of the conversation, in a sunken well: who and when, then it. */
export const CustomerMessageWell = memo(
  ({
    sender,
    sentAt,
    text,
  }: {
    sender: string;
    sentAt: string;
    text: string;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          paddingHorizontal: rpx(12),
          paddingVertical: rpx(10),
          borderRadius: rpx(10),
          backgroundColor: designRoles.bgSunken,
        }}
      >
        <Typography.Text size={rpx(12)} color={designRoles.textTertiary}>
          {`${sender} · ${formatDateTime(sentAt, 'MM-dd HH:mm')}`}
        </Typography.Text>
        <Typography.Text
          size={rpx(14)}
          lineHeight={rpx(21)}
          color={designRoles.textPrimary}
          mt={rpx(4)}
        >
          {text}
        </Typography.Text>
      </View>
    );
  },
);
